import { combineReducers } from 'redux'
import work from './work'
import files from './files'
import api from './api'
import common from './common'
import userinfo from './userInfo'

const index = combineReducers({
	work: work,
	files: files,
	api: api,
	common: common,
	userinfo: userinfo
})

export default index
